module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/728ba051b0ac7b16e0aa4a320f70f506.png";